import React from "react";
import SectionHeader from "../common/SectionHeader";

// rows: [{ label, value, mono }]
export default function StatGrid({ title, icon = "node", accent = "violet", rows = [], onRefresh }) {
  return (
    <div className="card">
      <SectionHeader
        icon={icon}
        title={title}
        accent={accent}
        right={onRefresh ? <button className="refresh-btn" onClick={onRefresh}>↻ Refresh</button> : null}
      />
      <div className="stat-rows">
        {rows.map((r, i) => (
          <div className="stat-row" key={i}>
            <span className="muted">{r.label}</span>
            <span className={r.mono ? "mono" : ""}>{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
